import { create } from 'zustand'

export type LiveStatus = 'connecting' | 'open' | 'reconnecting' | 'closed'

type Topic = { status: LiveStatus; attempt: number }

type LiveState = {
  /** One entry per open topic socket (`project:<key>`, `workspace:<id>`). */
  topics: Record<string, Topic>
  /** When the cache was last known to be current; shown in the "live updates lost" banner. */
  freshAt: number | null
  toasts: { id: number; level: 'down' | 'info'; text: string }[]
  setTopic: (topic: string, t: Topic | null) => void
  touch: () => void
  pushToast: (t: { level: 'down' | 'info'; text: string }) => void
  dropToast: (id: number) => void
}

let toastId = 0

export const useLive = create<LiveState>((set) => ({
  topics: {},
  freshAt: null,
  toasts: [],
  setTopic: (topic, t) =>
    set((s) => {
      const topics = { ...s.topics }
      if (t) topics[topic] = t
      else delete topics[topic]
      return { topics }
    }),
  touch: () => set({ freshAt: Date.now() }),
  pushToast: (t) => set((s) => ({ toasts: [...s.toasts.slice(-3), { id: ++toastId, ...t }] })),
  dropToast: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))

/** The worst-off socket, for the banner: the reader cares that something is behind. */
export function worstTopic(topics: Record<string, Topic>): Topic | null {
  let worst: Topic | null = null
  for (const t of Object.values(topics)) if (t.status === 'reconnecting' && (!worst || t.attempt > worst.attempt)) worst = t
  return worst
}
